var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.Mostrarlista
      ? _c("div", { staticClass: "ibox sombra-light" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ibox-content" },
            [
              _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.getreporte.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "b-overlay",
                    { attrs: { show: _vm.buttonDisable, rounded: "sm" } },
                    [
                      _c("div", { staticClass: "container" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Fecha de inicio")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "input-group" },
                                [
                                  _c(
                                    "b-form-datepicker",
                                    _vm._b(
                                      {
                                        staticClass: "mb-2",
                                        attrs: {
                                          id: "fechaInicioGrafico",
                                          placeholder: "Fecha de inicio",
                                          locale: _vm.datepicker.idioma,
                                        },
                                        model: {
                                          value: _vm.form.fechaInicio,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "fechaInicio",
                                              $$v
                                            )
                                          },
                                          expression: "form.fechaInicio",
                                        },
                                      },
                                      "b-form-datepicker",
                                      _vm.datepicker.etiquetas[
                                        _vm.datepicker.idioma
                                      ] || {},
                                      false
                                    )
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Fecha de término")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "input-group" },
                                [
                                  _c(
                                    "b-form-datepicker",
                                    _vm._b(
                                      {
                                        staticClass: "mb-2",
                                        attrs: {
                                          id: "fechaTerminoGrafico",
                                          placeholder: "Fecha de término",
                                          locale: _vm.datepicker.idioma,
                                        },
                                        model: {
                                          value: _vm.form.fechaTermino,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "fechaTermino",
                                              $$v
                                            )
                                          },
                                          expression: "form.fechaTermino",
                                        },
                                      },
                                      "b-form-datepicker",
                                      _vm.datepicker.etiquetas[
                                        _vm.datepicker.idioma
                                      ] || {},
                                      false
                                    )
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "offset-md-6 col-md-6" },
                            [
                              _c(
                                "b-button",
                                {
                                  class: "buscar-info-dashboard",
                                  attrs: {
                                    block: "",
                                    variant: "primary",
                                    type: "submit",
                                    disabled: _vm.buttonDisable,
                                  },
                                  on: { submit: _vm.getreporte },
                                },
                                [_vm._v("Buscar")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.mostrarGraficos
                  ? _c("div", { staticClass: "container" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-3" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn p-0 btn-block",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.mostrarReporte("Interacciones")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "widget navy-bg" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-3" }, [
                                    _c("i", {
                                      staticClass: "far fa-abacus fa-4x",
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-9 text-right" },
                                    [
                                      _c("span", [
                                        _vm._v(" Total Interacciones "),
                                      ]),
                                      _vm._v(" "),
                                      _c("h2", { staticClass: "font-bold" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.total_chatbot +
                                              _vm.total_whatsapp +
                                              _vm.total_facebook
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-3" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn p-0 btn-block",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.mostrarReporte("Whatsapp")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "widget navy-bg" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-3" }, [
                                    _c("i", {
                                      staticClass:
                                        "fab fa-whatsapp-square fa-4x",
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-9 text-right" },
                                    [
                                      _c("span", [_vm._v(" Total Whatsapp ")]),
                                      _vm._v(" "),
                                      _c("h2", { staticClass: "font-bold" }, [
                                        _vm._v(_vm._s(_vm.total_whatsapp)),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-3" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn p-0 btn-block",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.mostrarReporte("Facebook")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "widget navy-bg" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-3" }, [
                                    _c("i", {
                                      staticClass:
                                        "fab fa-facebook-square fa-4x",
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-9 text-right" },
                                    [
                                      _c("span", [_vm._v(" Total Facebook ")]),
                                      _vm._v(" "),
                                      _c("h2", { staticClass: "font-bold" }, [
                                        _vm._v(_vm._s(_vm.total_facebook)),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-3" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn p-0 btn-block",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.mostrarReporte("Chatbot")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "widget navy-bg" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-3" }, [
                                    _c("i", {
                                      staticClass: "fas fa-user-robot fa-4x",
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-9 text-right" },
                                    [
                                      _c("span", [_vm._v(" Total Chatbot ")]),
                                      _vm._v(" "),
                                      _c("h2", { staticClass: "font-bold" }, [
                                        _vm._v(_vm._s(_vm.total_chatbot)),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      !_vm.buttonDisable
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-lg-12" },
                              [
                                _c("div", { staticClass: "ibox-title" }, [
                                  _c("h5", [
                                    _vm._v(
                                      "Opciones Presionadas Whatsapp y Facebook"
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("data-table", {
                                  attrs: {
                                    id: _vm.dt.id,
                                    datos: _vm.dt2.datos,
                                    columnas: _vm.dt2.columnas,
                                    responsive: true,
                                    "font-size": 12,
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-6" }, [
                          _c("div", { staticClass: "ibox float-e-margins" }, [
                            _c("div", { staticClass: "ibox-title" }, [
                              _c("h5", [_vm._v("Total Interacciones")]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "ibox-content" }, [
                              _c("div", [_c("div", { attrs: { id: "pie2" } })]),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-6" }, [
                          _c("div", { staticClass: "ibox float-e-margins" }, [
                            _c("div", { staticClass: "ibox-title" }, [
                              _c("h5", [_vm._v("Total Estados Derivaciones")]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "ibox-content" }, [
                              _c("div", [_c("div", { attrs: { id: "pie" } })]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.Mostrarlista
      ? _c(
          "div",
          { staticClass: "ibox sombra-light" },
          [
            _c("div", { staticClass: "ibox-title" }, [
              _c("h5", [
                _c("i", { staticClass: "fal fa-chart-bar" }),
                _vm._v(
                  " Reporte " + _vm._s(_vm.tipo_reporte) + "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ibox-tools" }, [
                _c("div", { staticClass: "btn-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: { click: _vm.graficar },
                    },
                    [_vm._v("Volver")]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("transition", { attrs: { name: "fade" } }, [
              _c("div", { staticClass: "graficos" }, [
                _c("div", { staticClass: "ibox sombra-light" }, [
                  _c(
                    "div",
                    { staticClass: "ibox-content" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("data-table", {
                                attrs: {
                                  id: _vm.dt.id,
                                  datos: _vm.dt.datos,
                                  columnas: _vm.dt.columnas,
                                  responsive: true,
                                  "font-size": 12,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "detalles",
                                      fn: function (item) {
                                        return [
                                          _c("div", [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn btn-primary",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.abrirModal(item)
                                                  },
                                                },
                                              },
                                              [_vm._v("Ver Conversacion")]
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4061081376
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal fade",
                attrs: { role: "dialog", id: "Modal" },
              },
              [
                _c("div", { staticClass: "modal-dialog modal-lg" }, [
                  _c("div", { staticClass: "modal-content" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-md-12",
                            staticStyle: { display: "flex" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "ibox",
                                staticStyle: {
                                  overflow: "scroll",
                                  width: "418px",
                                  "justify-content": "center",
                                },
                              },
                              _vm._l(_vm.detalles, function (item, index) {
                                return _c("div", { key: index }, [
                                  _c(
                                    "div",
                                    {
                                      class:
                                        "conver " + _vm.revisa_direccion(item),
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.muestra_mensaje(item)) +
                                          "\n                                            "
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "font-size": "11px" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(item.created_at) +
                                              "\n                                            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [
        _c("i", { staticClass: "fal fa-chart-bar" }),
        _vm._v(" Reporte Interacciones Sin Watson\n            "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [_vm._v("Conversacion ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }